import { PushApi } from 'api';
import { useAuthMutation } from 'queries/query';

/** 행사 상세 참여자 알림 — 푸시 관리 목록에는 남지 않는다. */
function usePostDirect() {
  return useAuthMutation(PushApi.postDirect);
}

export default usePostDirect;
